<template>
  <div class="project-item-wrapper">
    <div class="head">
      <a-row type="flex" justify="center" align="middle">
        <a-col :span="24">
          <a-icon class="icon" :component="OrgIcon" />
          <span class="organization">{{ organization }}</span>
        </a-col>
      </a-row>
    </div>
    <div class="content">
      <!-- 标题 -->
      <div class="title">
        <a-tooltip>
          <template slot="title" v-if="data.name.length >= 25">{{ data.name }}</template>
          <p>
            <router-link :to="{ name: 'ProjectDetail', params: { projectId: data.id } }">
              <span v-more="25">{{ data.name && data.name.trim() }}</span>
            </router-link>
          </p>
        </a-tooltip>
      </div>
      <!-- 切换部分 -->
      <div
        class="switch-content"
        @mouseover="cardContentHover = true"
        @mouseleave="cardContentHover = false"
      >
        <!-- hover -->
        <template v-if="cardContentHover" transition="slide-x-transition">
          <div class="hover-content">
            <!-- 技术标签 -->
            <div class="tech-tags">
              <a-row>
                <a-col :span="24">
                  <CardTag
                    class="tag"
                    v-for="(item, index) in technologyTags"
                    :key="index"
                    :theme="'blue'"
                    :content="item"
                  ></CardTag>
                </a-col>
              </a-row>
            </div>
            <!-- 行业标签-->
            <div class="tech-tags">
              <a-row>
                <a-col :span="24">
                  <CardTag
                    class="tag"
                    v-for="(item, index) in industryTags"
                    :key="index"
                    :theme="'orange'"
                    :content="item"
                  ></CardTag>
                </a-col>
              </a-row>
            </div>
            <!-- 项目简介 -->
            <div class="description">
              <p>{{ data.purpose || '暂无项目简介' }}</p>
            </div>
          </div>
        </template>

        <!-- hover: false -->
        <template v-else transition="slide-x-reverse-transition">
          <!-- 期望合作方类型标签 -->
          <div class="partner-tags">
            <a-row>
              <a-col :span="24">
                <CardTag
                  class="tag"
                  v-for="(item, index) in partnerTags"
                  :key="index"
                  :content="item"
                ></CardTag>
              </a-col>
            </a-row>
          </div>

          <!-- 项目简介 -->
          <div class="description">
            <p>{{ data.purpose || '暂无项目简介' }}</p>
          </div>
        </template>
      </div>

      <!-- info (location | date) -->
      <a-row class="info" type="flex" justify="center" align="middle">
        <a-col :span="12" class="left">
          <div class="creator">
            <a-avatar :src="data.creator.avatar || defaultAvatarImg" size="small"></a-avatar>
            <div class="text">{{ data.creator.name }} {{ data.creator.post }}</div>
          </div>
        </a-col>
        <a-col :span="12" class="right">
          <div class="date">{{ data.createdAt | moment('YYYY-MM-DD') }} 发布</div>
        </a-col>
      </a-row>
    </div>

    <!-- footer -->
    <div class="footer">
      <a-row class="list" type="flex" justify="center" align="middle">
        <a-col :span="24">
          <a-col :span="8" class="item">
            <a-tooltip>
              <template slot="title">被收藏{{ data.favoritedCount }}次</template>

              <a-icon type="star" />
              {{ data.favoritedCount }}
            </a-tooltip>
          </a-col>
          <a-col :span="8" class="item">
            <a-tooltip>
              <template slot="title">{{ data.projectMattersCount }} 个项目事项</template>

              <a-icon type="ordered-list" />
              {{ data.projectMattersCount }}
            </a-tooltip>
          </a-col>
          <a-col :span="8" class="item">
            <a-tooltip>
              <template slot="title">{{ data.participantsCount }} 个项目参与者</template>

              <a-icon type="team" />
              {{ data.participantsCount }}
            </a-tooltip>
          </a-col>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import CardTag from '@/components/tools/CardTag'
import OrgIcon from '@/assets/icons/icon-org.svg?inline'

export default {
  components: {
    CardTag
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data () {
    return {
      OrgIcon,
      defaultAvatarImg: require('@/assets/images/default-avatar.png'),
      cardContentHover: false
    }
  },
  computed: {
    organization () {
      const { creator: { organization } } = this.data
      return (organization && organization.name) || '所属机构'
    },
    partnerTags () {
      const partners = this.data.expectedPartners
      if (partners && partners.filter(item => item).length) {
        return partners.map(partner => `寻找${partner}`)
      }
      return []
    },
    industryTags () {
      const arr = []
      const industryAreas = this.data.industryAreas
      if (industryAreas && industryAreas.filter(item => item).length) {
        arr.push(...industryAreas)
      }
      return arr
    },
    technologyTags () {
      const arr = []
      const technologyAreas = this.data.technologyAreas
      if (technologyAreas && technologyAreas.filter(item => item).length) {
        arr.push(...technologyAreas)
      }
      return arr
    }
  }
}
</script>

<style scoped lang="sass">
%item-tags
  margin: 0
  padding: 0
  line-height: 18px
  overflow: hidden
  .tag
    &:not(:last-child)
    margin-right: 4px

.project-item-wrapper
  background-color: #fff
  transition: box-shadow 0.25s ease-in
  border: 1px solid #e9e9e9
  border-radius: 2px
  &:hover
    box-shadow: -2px 8px 22px 0 rgba(0, 0, 0, 0.15)
    background-color: #fff

  .head
    color: #f4282d
    padding: 10px 20px
    border-bottom: 1px solid #e9e9e9
    .icon
      font-size: 16px
      width: 18px
      margin-right: 2px

    .organization
      font-size: 14px
      line-height: 20px

  .content
    height: 210px
    padding: 10px 0px 0px
    position: relative

    .title
      height: 26px
      padding: 0 20px
      overflow: hidden
      a
        display: block
        font-size: 18px
        font-weight: 700
        color: #333
        line-height: 26px

    .switch-content
      padding: 0 20px
      .partner-tags
        min-height: 18px
        max-height: 36px
        @extend %item-tags

      .description
        max-height: 60px
        overflow: hidden
        margin-top: 20px
        p
          color: #666
          font-size: 14px
          line-height: 20px
          overflow-wrap: break-word
          word-break: break-all

      .hover-content
        padding: 0
        .partner-tags
          height: 18px
          @extend %item-tags

        .tech-tags
          min-height: 18px
          max-height: 36px
          @extend %item-tags

    .info
      position: absolute
      bottom: 12px
      width: 100%
      padding: 0 20px
      color: #999
      font-size: 12px
      line-height: 18px
      vertical-align: middle

      .left
        text-align: left
        .creator
          font-size: 12px
          .text
            display: inline
            margin-left: 2px

      .right
        text-align: right
        .date
          font-size: 12px

  .footer
    padding: 5px 0 5px 10px
    background: #fafafa
    border-top: 1px solid rgba(102, 102, 102, 0.15)
    .list
      text-align: center
      .item
        &:not(:last-child)
          border-right: 1px solid rgba(0, 0, 0, 0.15)

      .location
        text-align: left
        .text
          color: #666
          font-size: 12px
          margin-left: 2px

</style>
